import { ReactNode } from 'react';

import {
  CheckCircleIcon,
  CrossCircleIcon,
  ExclamationMarkTriangleFillIcon,
} from '@grupoboticario/flora-react-icons';

export const iconMap: { [key: string]: ReactNode } = {
  updateInProgress: (
    <ExclamationMarkTriangleFillIcon color='$alert-standard' size={24} aria-hidden />
  ),
  updateCompleted: <CheckCircleIcon color='$success-standard' size={24} aria-hidden />,
  updateFailed: <CrossCircleIcon color='$error-standard' size={24} aria-hidden />,
  defaultButtonIcon: '',
};
